<div class="contact-container fixed-size-container body-content-area" #container id="contentToExport">
    <table style="margin: auto;" class="table-matrix">
        <tr class="header-area">
            <img src="../../../../assets/images/ford_logo.png" style="width: 80px;" >
            <div class="sub-title new-font-header" style="justify-content: end;color: red;left:39%; font-size: 16px;">CONFIDENTIAL</div>
            <div class="sub-title new-font-header" style="font-size: 20px;">TRANSPORTATION PROCUREMENT RATE AGREEMENT</div>
            <div class="key new-font-size"><span>Part I of Service Contract (Effective Date: {{ data.InitialContractEffectiveDate |date:'dd/MM/yyyy'}}</span>)</div>
        </tr>
        <hr>
        <tr class="portion-container" style="display: flex;justify-content: space-between;width: 96%;">
            <div class="portion-one" style=" flex: 0 0 60%;">
                <div class="items new-font-size" style="text-transform: capitalize; font-weight: 700;">{{data.Name}}</div>
                <div class="items">
                    <span class="key new-font-size">GSDB:</span>
                    <span class="new-font-size"> {{data.GSDB}}</span>
                </div>
                <div class="items">
                    <div class="new-font-size"> {{data.Street}}</div>
                    <div class="new-font-size"> {{data.City}}, {{data.Postcode}}</div>
                    <div class="new-font-size"> {{data.Country}}</div>
                    <!-- <div class="new-font-size"> {{data.Postcode}}</div> -->
                </div>
                <div class="items">
                    <span class="key new-font-size">Telephone:</span>
                    <span class="new-font-size"> {{data.Telephone}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">E-Mail:</span>
                    <span class="new-font-size"> {{data.Email}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Contact:</span>
                    <span class="new-font-size"> {{data.ContactName}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Commodity:</span> 
                    <span class="new-font-size"> {{data.Commodity}}</span>
                </div>
                <div class="items">
                    <span class="header-key new-font-size">Brief Description of service to be performed:</span> 
                    <span class="new-font-size" [innerHTML]="getHtml(appService.deResingDoubleQuotess(data.DescriptionofService))"></span>
                </div>
                <div class="items">
                    <span class="header-key new-font-size">RA Volume Guarantees:</span> 
                    <span class="new-font-size"> {{appService.deResingDoubleQuotess(data.VolumeGuarantees)}}</span>
                </div>
                <div class="items">
                    <span class="header-key new-font-size">Market Test:</span> 
                    <span class="new-font-size"> {{appService.deResingDoubleQuotess(data.MarketTest)}}</span>
                </div>
                <br>
                <div class="items">
                    <span class="header-key new-font-size">Rates:</span> 
                    <span class="new-font-size"> See rate tables sheets attached</span>
                </div>
            
             <div class="items specification-section">
  <span class="header-key new-font-size">Specification:</span>
  <span class="new-font-size" [innerHTML]="getHtml(appService.deResingDoubleQuotess(data.Specification))">
  </span>
</div>
            
                <div class="items">
                    <span class="header-key new-font-size">Contract Duration:</span> 
                    <span class="new-font-size"> {{data.ContractDuration}} Years</span>
                </div>
            
                <div class="items">
                    <span class="header-key new-font-size">Auto Extension:</span> 
                    <span class="new-font-size"> {{data.AutoExtensionFlag}}. {{appService.deResingDoubleQuotess(data.AutoExtensionComment)}}</span>
                </div>
                <br>
                <div class="items">
                    <span class="header-key new-font-size">Buyer Name:</span> 
                    <span class="new-font-size"> {{data['Buyer Name']}}</span>
                </div>
                <div class="items">
                    <span class="header-key new-font-size">Email:</span> 
                    <span class="new-font-size"> {{data.BuyerEmail}}</span>
                </div>
                <div class="items">
                    <span class="header-key new-font-size">Date:</span> 
                    <span class="new-font-size"> {{data.ModifiedOn?this.tableService.checkOnInvalidDate(data.ModifiedOn):''}}</span>
                </div>
                <div class="items">
                    <span class="header-key new-font-size">Telephone:</span> 
                    <span class="new-font-size"> {{data.BuyerTelephone}}</span>
                </div>
                <div class="items">
                    <span class="header-key new-font-size">Location:</span> 
                    <span class="new-font-size"> {{data.BuyerLocation}}</span>
                </div>
                
                <!-- <br> -->
                <!-- <div class="items">
                    <span class="header-key new-font-size">Buyer Code:</span> 
                    <span class="new-font-size"> {{data['BuyerCode']}}</span>
                </div> -->
           
            </div>
            <br>

            <div class="portion-two" style=" flex: 0 0 36%;">
                <div class="items">
                    <span class="key new-font-size">Rate Agreement Nº (ID):</span>
                    <span class="new-font-size"> {{data.RateAgreementNumber}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Revision Number:</span> 
                    <span class="new-font-size"> {{data.RevisionNumber}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Initial Contract Effective Date:</span>
                    <span class="new-font-size"> {{data.InitialContractEffectiveDate |date:'dd/MM/yyyy'}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Effective Date:</span> 
                    <span class="new-font-size"> {{ data.EffectiveDate |date:'dd/MM/yyyy'}}</span>
                    
                </div>
                <div class="items">
                    <span class="key new-font-size">Expiry Date:</span> 
                    <span class="new-font-size"> {{data.ExpiryDate |date:'dd/MM/yyyy'}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Reason for Revision:</span> 
                    <span class="new-font-size" [innerHTML]="getHtml(appService.deResingDoubleQuotess(data.ReasonforRevision))"></span>
                </div>

                <br>
                <div class="items">
                    <span class="key new-font-size">Supersedes RA Nº (ID):</span> 
                    <span class="new-font-size"> {{data.SupersedesRANo}}</span>
                </div>
                <br>
                <div class="items">
                    <span class="key new-font-size">Payment Terms:</span> 
                    <span class="new-font-size"> {{data.PaymentTerms}} Days
                    </span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Currency:</span> 
                    <span class="new-font-size"> {{data.Currency }} (<span>{{ data.CurrencyID === 22 ? '€' : '£' }}</span>)</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">VAT:</span> 
                    <span class="new-font-size"> {{data.VATCode}}</span>
                </div>

            </div>
        </tr>
        <tr class="portion-container" style="display: flex;justify-content: space-between;width: 96%;">
            <div class="portion-one" style=" flex: 0 0 60%;">
                <div class="items">
                    <span class="header-key new-font-size">GIS2 Classification:</span> 
                    <span class="new-font-size"> {{data.GISClassification}}</span>
                </div>
                <div class="items">
                    <span class="header-key new-font-size">GIS1 Item Number:</span> 
                    <span class="new-font-size"> {{data.GISNumber}}</span>
                </div>
           
            </div>
            <br>

            <div class="portion-two" style=" flex: 0 0 36%;">
                <div class="items" style="margin-top: 0px;">
                    <span class="key new-font-size">Date Issued:</span> 
                    <span class="new-font-size"> {{ data.CreatedOn |date:'dd/MM/yyyy'}}</span>
                    
                </div>
                <div class="items" style="margin-top: 0px;">
                    <span class="key new-font-size">Date Revised:</span> 
                    <span class="new-font-size"> {{ data.ModifiedOn |date:'dd/MM/yyyy'}}</span>
                    
                </div>

            </div>
        </tr>
       
                <tr style="display: inline;text-align: center; " class="alignBottom">
                    <div class="pdfAlignBottom">
                     <hr>
                    <div  class="new-font-size">
                        The Carrier/Provider will sell and deliver the services as specified in the Service Contract and in accordance to the Master Service Agreement
                    </div>
                </div>
                </tr>
    </table>
    <div style="width: 100%;margin: auto;" *ngIf="exportPDFTableList&&exportPDFTableList.length>0">
        <!-- <hr> -->
        <br><br>
        <div style="page-break-after: always;"></div>
        @for(i of exportPDFTableList; track $index){
            <app-export-pdf-ltl class="table-matrix" [raData]="data" *ngIf="i?.type==='ltl'" type="pdf" [data]="i"></app-export-pdf-ltl>
            <!-- <hr><br><br> -->
            <app-export-pdf-fixed class="table-matrix" [raData]="data" *ngIf="i?.type==='fixed'" type="pdf" [data]="i"></app-export-pdf-fixed>
            <!-- <hr><br><br> -->
            <app-export-pdf-table class="table-matrix" [raData]="data" *ngIf="i?.type==='ftl'" type="pdf" [data]="i" #ftltable></app-export-pdf-table>
            <app-export-aditional-charges class="table-matrix" [raData]="data" [type]="i?.type" *ngIf="i?.type==='ftl' || i?.type==='fixed' || i?.type==='ltl'"  [data]="i" ></app-export-aditional-charges>
            <!-- <hr> -->
            <br>
        }
        <!-- <ng-container *ngFor="let i of appService.exportPDFTableList; index as index">
            {{ delayRender(index) }}
          </ng-container> -->
    </div>
   
</div>
